import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Screens from '..';
import GameListInterface from '../../api/GameListInterface';
import GameProviders, { providersList } from '../../api/GameInterface/providers';
import PlayerInterface from '../../api/PlayerInterface';
import NavigationConstants from '../../components/LobbyOverlay/NavigationConstants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import audio from '../../utils/audio';
import Utils from '../../utils';
import { store } from '../../state/store';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
import { FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
import { FTUE_STEPS_KEYS } from '../../constants';
import { skipTutorialGame as _skipTutorialGame } from '../../components/OnboardingLayer/utils/skipTutorialGame';

var Game = /*#__PURE__*/function (_Component) {
  _inherits(Game, _Component);

  var _super = _createSuper(Game);

  function Game() {
    var _this;

    _classCallCheck(this, Game);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      gameInterface: null,
      gameLink: null,
      provider: null,
      netEntConfig: null,
      embedData: null
    };

    _this._backButtonHandler = function () {
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Home);
    };

    _this.showAdBlockerPopup = function () {
      var _this$props = _this.props,
          lastTimeAdBlockerSeen = _this$props.lastTimeAdBlockerSeen,
          setLastTimeAdBlockerSeen = _this$props.setLastTimeAdBlockerSeen;
      var newTime = new Date();
      var timeLimit = 86400000; // 24 * 60 * 60 * 1000 = 24 hours in ms;

      var timeDiff = !lastTimeAdBlockerSeen ? 0 : newTime - new Date(lastTimeAdBlockerSeen);

      if (timeDiff > timeLimit || timeDiff === 0) {
        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.AdBlocker));
        setLastTimeAdBlockerSeen(newTime);
      }
    };

    _this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var gid, game, eventPayload, gameInterface;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.props.setNavState(NavigationConstants.HIDE_BOTTOM);

              gid = _this.props.navigation.getParam('gid', '0');

              _this.props.setGameId(gid);

              _this.props.setLastGameVisited(gid);

              _this.trackOpenedGamesAmount(gid);

              if (!(gid && _this.props.token.token)) {
                _context.next = 19;
                break;
              }

              _context.next = 8;
              return GameListInterface.initGame(gid);

            case 8:
              game = _context.sent;

              if (game.PROVIDER) {
                _context.next = 14;
                break;
              }

              _this.props.onGameUnavailable();

              eventPayload = {
                description: "This game - ".concat(gid, " is currently not available"),
                code: 2
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              return _context.abrupt("return");

            case 14:
              gameInterface = new GameProviders[game.PROVIDER]({
                RFValue: _this.props.RFValue,
                deviceInfo: _this.props.deviceInfo,
                dimension: _this.props.dimension,
                gameType: game.GAME_TYPE,
                BetInfo: _this.parseBetInfo(_objectSpread({}, game.BET_INFO)),
                ExitFunc: _this._backButtonHandler,
                GameReady: function GameReady() {
                  console.log('Game provider has told us that it is ready');
                },
                OutOfCoins: function OutOfCoins() {
                  console.log('Game provider has told us that the user is out of coins');
                }
              });

              if (game.PROVIDER !== providersList.NETENT) {
                _this.setState({
                  provider: game.PROVIDER,
                  gameInterface: gameInterface,
                  gameLink: game.URL,
                  netEntConfig: null,
                  embedData: game.EMBED_DATA
                });
              } else {
                _this.setState({
                  provider: game.PROVIDER,
                  gameInterface: gameInterface,
                  gameLink: game.URL.game_server_url,
                  netEntConfig: {
                    gameId: game.PROVIDER_GAME_ID,
                    languagePrefix: 'SC',
                    staticServerURL: game.URL.static_server_url,
                    gameServerURL: game.URL.game_server_url,
                    sessionId: game.SESSION_ID
                  }
                });
              }

              audio.pauseSfx();
              _context.next = 20;
              break;

            case 19:
              throw Error("[GameView] gameId or token not set.");

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this.getNewGameLink = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var gid, game, eventPayload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              gid = _this.props.navigation.getParam('gid', '0');

              _this.props.setGameId(gid);

              if (!(gid && _this.props.token.token)) {
                _context2.next = 15;
                break;
              }

              _context2.next = 5;
              return GameListInterface.initGame(gid);

            case 5:
              game = _context2.sent;

              if (game.PROVIDER) {
                _context2.next = 11;
                break;
              }

              _this.props.onGameUnavailable();

              eventPayload = {
                description: "This game - ".concat(gid, " is currently not available"),
                code: 2
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              return _context2.abrupt("return");

            case 11:
              if (game.PROVIDER !== providersList.NETENT) {
                _this.setState({
                  provider: game.PROVIDER,
                  gameLink: game.URL,
                  netEntConfig: null,
                  embedData: game.EMBED_DATA
                });
              } else {
                _this.setState({
                  provider: game.PROVIDER,
                  gameLink: game.URL.game_server_url,
                  netEntConfig: {
                    gameId: game.PROVIDER_GAME_ID,
                    languagePrefix: 'SC',
                    staticServerURL: game.URL.static_server_url,
                    gameServerURL: game.URL.game_server_url,
                    sessionId: game.SESSION_ID
                  }
                });
              }

              return _context2.abrupt("return", game);

            case 15:
              throw Error("[GameView] gameId or token not set.");

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this.parseBetInfo = function (betInfo) {
      if (!betInfo) return;

      if (betInfo.increments) {
        betInfo.lines = parseInt(betInfo.lines);
        betInfo.index = parseInt(betInfo.index);
        betInfo.increments = betInfo.increments.split(':');

        for (var i = 0; i < betInfo.increments.length; i++) {
          betInfo.increments[i] = parseInt(betInfo.increments[i]);
        }
      }

      if (betInfo.bonusXPThreshold && betInfo.bonusXPMultiplier) {
        betInfo.bonusXP = {
          wagerNeeded: parseFloat(betInfo.bonusXPThreshold),
          multiplier: betInfo.bonusXPMultiplier
        };
      }

      _this.props.setBetInfo(betInfo);

      return betInfo;
    };

    _this.checkFtueStep = function () {
      var ftueStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      _this.props.setOnboardingFtueStep(ftueStep);

      if (position) _this.props.setOnboardingHighlightedPosition(position, message);
      if (ftueStep === FTUE_STEPS_KEYS.CLICKED_ON_SPINNER) _this.props.setGameState(null);
    };

    _this.trackOpenedGamesAmount = function (gameId) {
      var gamesOpenedAmount = _this.props.gamesOpenedAmount + 1;
      var amountToTrack = _this.props.appsflyerGamesOpenedAmountConfig;

      if (gamesOpenedAmount == amountToTrack) {
        var balance = store.getState().coin.value || 0;
        var level = store.getState().levelInfo.level || 1;
        var tier = store.getState().playerInfo.memberLevel || '';
        var eventPayload = {
          level: level,
          balance: balance,
          tier: tier,
          gameId: gameId,
          gamesOpenedAmount: gamesOpenedAmount
        };
        Logger.sendEvent(EVENT_TYPES.GAMES_OPENED_AMOUNT, eventPayload);
      }

      _this.props.setGamesOpenedAmount(gamesOpenedAmount);
    };

    return _this;
  }

  _createClass(Game, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      audio.pauseMusic();
      audio.playSfx('crowdsTalking', true, 0.7);
      this.init();

      if (Utils.getPlatform() === 'web' && this.props.adBlockerEnabled) {
        this.showAdBlockerPopup();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var newGameId = this.props.gameId.gameId;
      var oldGameId = prevProps.gameId.gameId;

      if (oldGameId && newGameId !== oldGameId) {
        this.init();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var token, device;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_SNEAK_PEEK_END_DATE, undefined)); // This exists to update the players balance upon leaving the screen

                token = store.getState().token.token;
                device = store.getState().device;

                if (!(token && device.isConnected)) {
                  _context3.next = 11;
                  break;
                }

                _context3.prev = 4;
                _context3.next = 7;
                return PlayerInterface.getPlayerExtras();

              case 7:
                _context3.next = 11;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](4);

              case 11:
                this.props.clearSpinEvent();
                this.props.setGameInfo({
                  gameId: '',
                  gameType: '',
                  gameProvider: '',
                  isEmbedded: '',
                  embedUrl: ''
                });
                audio.playMusic('backgroundMusic');

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 9]]);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          ftueStep = _this$props2.ftueStep,
          clearOnboarding = _this$props2.clearOnboarding,
          actionCommands = _this$props2.actionCommands,
          gameState = _this$props2.gameState;

      var _useFeatureFlags = useFeatureFlags(),
          hasFeature = _useFeatureFlags.hasFeature;

      var sneakPeekTimer = hasFeature(FE_SNEAK_PEEK) && QueryParamsProxy.findParam(RouteParamConstants.PARAM_SNEAK_PEEK_END_DATE, false);
      return this.props.render( // Pass state and handlers to platform renderer
      {
        gameInterface: this.state.gameInterface,
        gameProvider: this.state.provider,
        netEntConfig: this.state.netEntConfig,
        gameLink: this.state.gameLink,
        embedData: this.state.embedData,
        getNewGameLink: this.getNewGameLink,
        checkFtueStep: this.checkFtueStep,
        gameId: this.props.navigation.getParam('gid', '0'),
        ftueStep: ftueStep,
        clearOnboarding: clearOnboarding,
        gameState: gameState,
        sneakPeekTimer: sneakPeekTimer,
        skipTutorialGame: function skipTutorialGame() {
          return _skipTutorialGame(ftueStep, clearOnboarding, actionCommands);
        }
      });
    }
  }]);

  return Game;
}(Component);

export { Game as default };